import styled from 'styled-components';

export const PopupContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const PopupContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
`;

export const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const TitleIcon = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
  }
`;

export const Message = styled.p`
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  color: #333;
  margin: 0 0 24px 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ActionButton = styled.button`
  color: white;
  border: none;
  border-radius: 50px;
  padding: 8px 12px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  width: 40%;
  background: var(--color-purple-300, #7200E0);

  transition: background-color 0.2s;

   &:hover {
    background: #5a00b3;
  }
`;
